import React from 'react';

function MarketSummaryReport() {
  return (
    <div className="market-summary-wrapper">
      <h2 className="static-title">Market Summary Report</h2>
      <div className="market-summary-table-container">
        <table>
          <thead>
            <tr>
              <th align="left" />
              <th align="left">Oct-21</th>
              <th align="left">Oct-20</th>
              <th align="left">% Chg</th>
              <th align="left">2021 YTD</th>
              <th align="left">2020 YTD</th>
              <th align="left">% Chg</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left">Absorption Rate</td>
              <td align="left">1.58</td>
              <td align="left">2.59</td>
              <td align="left">-39.00</td>
              <td align="left">1.52</td>
              <td align="left">3.57</td>
              <td align="left">-57.42</td>
            </tr>
            <tr>
              <td align="left">Average List Price</td>
              <td align="left">$1,061,677</td>
              <td align="left">$878,888</td>
              <td align="left">20.80</td>
              <td align="left">$720,991</td>
              <td align="left">$625,641</td>
              <td align="left">15.24</td>
            </tr>
            <tr>
              <td align="left">Median List Price</td>
              <td align="left">$572,500</td>
              <td align="left">$449,000</td>
              <td align="left">27.51</td>
              <td align="left">$400,000</td>
              <td align="left">$357,950</td>
              <td align="left">11.75</td>
            </tr>
            <tr>
              <td align="left">Average Sale Price</td>
              <td align="left">$594,452</td>
              <td align="left">$558,542</td>
              <td align="left">6.43</td>
              <td align="left">$615,287</td>
              <td align="left">$504,072</td>
              <td align="left">22.06</td>
            </tr>
            <tr>
              <td align="left">Median Sale Price</td>
              <td align="left">$390,000</td>
              <td align="left">$339,000</td>
              <td align="left">15.04</td>
              <td align="left">$371,900</td>
              <td align="left">$318,000</td>
              <td align="left">16.95</td>
            </tr>
            <tr>
              <td align="left">Average CDOM</td>
              <td align="left">46</td>
              <td align="left">77</td>
              <td align="left">-40.26</td>
              <td align="left">68</td>
              <td align="left">86</td>
              <td align="left">-20.93</td>
            </tr>
            <tr>
              <td align="left">Median CDOM</td>
              <td align="left">10</td>
              <td align="left">18</td>
              <td align="left">-44.44</td>
              <td align="left">8</td>
              <td align="left">27</td>
              <td align="left">-70.37</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MarketSummaryReport;
